/* eslint-disable no-throw-literal */
import React, { useContext, useEffect } from 'react'
import { Routes, Route, useParams } from 'react-router-dom'
import CommunityOverview from './CommunityOverview'
import "./Community.css"
import CommunityNavbar from './CommunityNavbar'
import { CommunityContext } from './CommunityContext'
import { Col, Container, Row } from 'react-bootstrap'
import CommunityRoom from './CommunityRoom'
import CommunitySettings from './settings/CommunitySettings'
import CommunityAnnouncement from './CommunityAnnouncement'
import CommunityCertainPost from '../community/CommunityCertainPost';
import CommunityMembers from './CommunityMembers'

const Community = () => {
  const { communityData, fetchCommunityData, userData, memberData } = useContext(CommunityContext)
  let { id } = useParams()

  useEffect(() => {
    fetchCommunityData(id)
  }, [])

  return (
    <div id="community">
      <CommunityNavbar/>
      <Container style={{marginBottom:"16px"}}>
        <Row>
          <Routes>
            {/*No member list*/}
            {userData.isAdmin && <Route path="settings" element={<CommunitySettings/>}/>}
            {/*Show member list*/}
            <Route path='*' element={
              <>
                <Col xs="12" lg="9">
                  <Routes>
                    <Route path="*" element={<CommunityOverview/>}/>
                    <Route path="announcement" element={<CommunityAnnouncement/>} />
                    <Route path="discussion" element={<CommunityRoom/>}/>
                    <Route path="discussion/:postId" element={<CommunityCertainPost/>} />
                  </Routes>
                </Col>
                <Col xs="12" lg="3">
                  <CommunityMembers memberData={memberData} admin={communityData.admin}/>
                </Col>
              </>
            } />
          </Routes>
        </Row>
      </Container>
    </div>
  )
}

export default Community